import { render, staticRenderFns } from "./ReviewNeedsAttentionBadge.vue?vue&type=template&id=5125c41c&scoped=true&"
import script from "./ReviewNeedsAttentionBadge.vue?vue&type=script&lang=js&"
export * from "./ReviewNeedsAttentionBadge.vue?vue&type=script&lang=js&"
import style0 from "./ReviewNeedsAttentionBadge.vue?vue&type=style&index=0&id=5125c41c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125c41c",
  null
  
)

export default component.exports